export default function(...args) {
  const urlParts = args.map((part) => part.replace(/^\/|\/$/g, ''));
  let url = urlParts.join('/');
  url = `${url}/`;
  return url;
}
